export { refetchList } from './api'

import { CONSTS } from 'config/objectConst'

import type { Campaign, State } from './types'

export const isInitState = (state: State) => state === 'Compose'
export const isActive = (state: State) => !isInitState(state)
export const isAllowAddSteps = (campaign: Campaign) =>
	isInitState(campaign.state) && !campaign.archived

const enum ErrorName {
	None,
	EmptyName,
	TooLong
}

const errorTexts: Partial<Record<ErrorName, string>> = {
	[ErrorName.TooLong]: `The campaign name should be less than ${CONSTS.CAMPAIGN_MAX_LENGTH} characters`
}

validateName.texts = errorTexts

function validateName(name: string) {
	if (name.length > CONSTS.CAMPAIGN_MAX_LENGTH) {
		return ErrorName.TooLong
	}

	return name ? ErrorName.None : ErrorName.EmptyName
}

export { ErrorName, validateName }
